import { render, staticRenderFns } from "./ModulesSkeleton.vue?vue&type=template&id=3845d19d&"
import script from "./ModulesSkeleton.vue?vue&type=script&lang=ts&"
export * from "./ModulesSkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports